import React, { useEffect, useState } from "react";
import auctionApiClient from "../../auctions-list-page/AuctionApiClient";
import Spinner from "../../common/Spinner";
import events from "../../events";
import formatPrice from "../../utils/formatPrice";
import Modal from "../Modal";
import styles from "./BuyNowButton.module.scss";
const CHRISTIANIA_TEST_BG_COLOR = "#2D2D2D";
export function BuyNowButton(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [isHover, setIsHover] = useState(false);
    const [isChristianiaTest, setIsChristianiaTest] = useState(false);
    useEffect(() => {
        const checkClass = () => {
            setIsChristianiaTest(document.body.classList.contains('christiania-test'));
        };
        checkClass();
        const observer = new MutationObserver(checkClass);
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        return () => observer.disconnect();
    }, []);
    const buyNow = async () => {
        setIsLoading(true);
        try {
            await auctionApiClient.bidLot(props.lotId, {
                maximumAmount: props.price,
                buyNow: true,
            });
            props.onBuyNow(props.lotId);
        }
        catch (error) {
            if ((error === null || error === void 0 ? void 0 : error.status) === 401) {
                props.saveItemPositionState(props.lotId);
                events.openLogin.trigger({ open: true, centeredFixed: true });
            }
            else {
                console.error(error);
            }
        }
        finally {
            setIsLoading(false);
        }
    };
    const btnClicked = () => {
        if (!document.body.dataset.username) {
            props.saveItemPositionState(props.lotId);
            events.openLogin.trigger({ open: true });
            return;
        }
        setModalOpen(true);
    };
    const christianiaStyle = isChristianiaTest ? (isHover || isLoading
        ? { backgroundColor: "white", color: CHRISTIANIA_TEST_BG_COLOR, border: `1px solid ${CHRISTIANIA_TEST_BG_COLOR}` }
        : { backgroundColor: CHRISTIANIA_TEST_BG_COLOR, color: "white", border: `1px solid ${CHRISTIANIA_TEST_BG_COLOR}` }) : undefined;
    return (React.createElement("div", { className: styles.buyNowBtn },
        React.createElement("button", { className: styles.bidButton, disabled: isLoading, onClick: btnClicked, onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false), style: christianiaStyle },
            React.createElement("span", { style: { visibility: isLoading ? "collapse" : "visible" } }, props.strings.aftersaleBuyNowBtn),
            isLoading && React.createElement(Spinner, { size: "mini", position: "absolute-center" })),
        React.createElement(Modal, { isOpen: modalOpen, onClose: () => setModalOpen(false), title: props.strings.aftersaleModalTitle, okBtnLabel: props.strings.aftersaleModalOk, onOk: buyNow, cancelBtnLabel: props.strings.aftersaleModalCancel },
            React.createElement("div", { className: styles.modalTextContent },
                React.createElement("p", { className: styles.special }, props.strings.aftersaleInfo),
                React.createElement("p", null,
                    props.strings.aftersaleModalObjectNrPrompt,
                    ": ",
                    props.objectNumber),
                React.createElement("p", null,
                    props.strings.aftersaleModalPrice,
                    ": ",
                    formatPrice(props.price))))));
}
